export interface scrappingData {
  posted_date?: Date | null; 
  position?: string;
  company?: string;
  advert_keyword?: string; // keyword search inside the scraped advert text
  location?: string;
  contactPerson?: string;
  phone?: string;
  email?: string;
  source?: string;
  vat?: string;
  office?: Array<number | string>;
  type?: number;
  currentPage: number;
  recordsPerPage: number;
  orderByColumn: string;
  orderIn: string;
  fromDate: Date | null;
  toDate: Date | null;
  post_code?: Array<number | string>; // CR: multi-select postal codes
  km?: { value: number; label: string } | null; // km radius: distance around selected postal code(s)
}

export const intialscrappingData: scrappingData = {
  posted_date: null,
  position: "",
  company: "",
  advert_keyword: "", // keyword search inside the scraped advert text
  location: "",
  contactPerson: "",
  phone: "",
  email: "",
  source: "",
  vat: "",
  office: [],
  type: 1,
  currentPage: 1,
  recordsPerPage: 10,
  orderByColumn: "",
  orderIn: "",
  fromDate: null,
  toDate: null,
  post_code: [], // CR: multi-select postal codes
  km: null // km radius: no radius selected by default
};

export interface dropDownList {
  status: Array<{ id: number; name: string }>;
  sources: Array<{ id: number; name: string }>;
  countries: Array<{ id: number; name: string }>;
  postCodes: Array<{ value: number; label: string }>; // CR: postal code options
}

export const intialDropDownList: dropDownList = {
  status: [],
  sources: [],
  countries: [],
  postCodes: [],
};